<template>
    <section>
        <div class="row mt-5">
            <div class="col">
                <div class="row">
                    <div class="col-xl-6 col-lg-12 mb-4">
                        <div class="card shadow-sm border-0 h-100">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Ringkasan Data Siswa
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body px-5">
                                <div class="row">
                                    <div class="col-auto">
                                        <div v-bind:style="'background-image: url(' + student.imageUrl +')'" class="user-avatar rounded-circle"></div>
                                    </div>
                                    <div class="col ml-2">
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-sm-6 col-12 p-1">
                                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                                    Nama Lengkap
                                                </label>
                                            </div>
                                            <div class="col-sm-6 col-12 px-1">
                                                <h4 class="mb-0 font-weight-medium text-loading">
                                                    {{ student.user.name }}
                                                </h4>
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-sm-6 col-12 p-1">
                                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                                    Nomor Peserta BTA
                                                </label>
                                            </div>
                                            <div class="col-sm-6 col-12 px-1">
                                                <h4 class="mb-0 font-weight-medium text-loading">
                                                    {{ student.identity }}
                                                </h4>
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-sm-6 col-12 p-1">
                                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                                    Cabang BTA
                                                </label>
                                            </div>
                                            <div class="col-sm-6 col-12 px-1">
                                                <h4 class="mb-0 font-weight-medium text-loading">
                                                    {{ student.branch.name }}
                                                </h4>
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-sm-6 col-12 p-1">
                                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                                    Asal Sekolah
                                                </label>
                                            </div>
                                            <div class="col-sm-6 col-12 px-1">
                                                <h4 class="mb-0 font-weight-medium text-loading">
                                                    {{ student.school.name }}
                                                </h4>
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-sm-6 col-12 p-1">
                                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                                    Kelas
                                                </label>
                                            </div>
                                            <div class="col-sm-6 col-12 px-1">
                                                <h4 class="mb-0 font-weight-medium text-loading">
                                                    {{ student.btaGrade.name }}
                                                </h4>
                                            </div>
                                        </div>
                                       <!-- <div class="row mb-1 align-items-center">
                                            <div class="col-sm-6 col-12 p-1">
                                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                                    Pola
                                                </label>
                                            </div>
                                            <div class="col-sm-6 col-12 px-1">
                                                <template v-if="student.studentVerified && student.studentVerified.pattern">
                                                    <h4 class="mb-0 font-weight-medium text-loading">
                                                        {{ student.studentVerified.pattern.periods.map(period => $moment.weekdays(period.day)).join(", ") }}
                                                    </h4>
                                                </template>
                                            </div>
                                        </div> -->
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-sm-6 col-12 p-1">
                                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                                    Nilai TO PTN Tertinggi
                                                </label>
                                            </div>
                                            <div class="col-sm-6 col-12 px-1">
                                                <h4 class="mb-0 font-weight-medium text-loading">
                                                    <span v-if="student.maxGroupScore" class="text-loading">{{ student.maxGroupScore }}</span>
                                                    <i class="fa fa-minus" v-else></i>
                                                </h4>
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-sm-6 col-12 p-1">
                                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                                    Nilai TES EVALUASI Tertinggi
                                                </label>
                                            </div>
                                            <div class="col-sm-6 col-12 px-1">
                                                <h4 class="mb-0 font-weight-medium text-loading">
                                                    <span v-if="student.maxSubjectScore" class="text-loading">{{ student.maxSubjectScore }}</span>
                                                    <i class="fa fa-minus" v-else></i>
                                                </h4>
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="row mb-1 align-items-center" v-for="status in statuses">
                                            <div class="col-sm-6 col-12 p-1">
                                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                                    {{ status.name }}
                                                </label>
                                            </div>
                                            <div class="col-sm-6 col-12 px-1">
                                                <h4 class="mb-0 font-weight-medium text-loading">
                                                    {{ student[status.name] }} dari {{ student.totalAttendance }} sesi
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
		    <div class="col-auto ">
                        <button v-b-tooltip.hover title="Download Kartu Peserta Siswa" v-on:click="downloadCard" type="button" class="btn btn-sm btn-danger px-3" >
                		Download Kartu Peserta Siswa
                	</button>
			<button v-b-tooltip.hover title="Download Petunjuk Penggunaan Web"  type="button" class="btn btn-sm btn-danger px-3" > <a href="https://drive.google.com/file/d/1bGgeVCYplH7rjuvP_uiEkUbjZ5QP2Mzf/view?usp=sharing">
                		Download Petunjuk Penggunaan Web
                	</a></button>
                    </div>

                    <!--<div class="col-xl-6 col-lg-12">
                        <div class="row">
                            <template v-for="donut in graphData.donuts">
                                <div class="col-12 col-xl-12 col-md-6 mb-4" v-if="donut.series[0].data.length">
                                    <div class="card shadow-sm border-0">
                                        <div class="card-header background-primary">
                                            <div class="row justify-content-end">
                                                <div class="col">
                                                    <span class="h4 font-weight-medium text-white mb-0">
                                                        Rekap Kehadiran Siswa {{ donut.series[0].name }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body px-5">
                                            <div class="position-relative graph-wrapper">
                                                <div class="w-100 donut-chart">
                                                    <IEcharts v-bind:option="donut" resizable />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>-->
                </div>
                <div class="row">
                    <div class="col mb-5">
                        <div class="slim-scroll scroll-x" v-dragscroll>
                            <div class="card shadow-sm mb-4 border-0" style="min-width: 100%;" v-bind:style="{width: (250 * graphData.bar.xAxis[0].data.length) + 'px'}">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Grafik Nilai TO
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body px-5">
                                    <div style="height: 500px;">
                                        <IEcharts v-bind:option="graphData.bar" resizable />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	<div class="row">
            <div class="col text-center mt-5">
                <Adsense v-bind:data-ad-client="googleAdsClientKey" data-ad-slot="8773918261"></Adsense>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import IEcharts from 'vue-echarts-v3/src/full.js';
    import { dragscroll } from 'vue-dragscroll';
    import { semesters } from '@/params.js';
    import qs from 'qs';

    export default {
        name: "AccountStudentIndex",
        directives: {dragscroll},
        components: {
            IEcharts: IEcharts
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            let colors = ['#38EF7D', '#88429B', '#FEC401', '#d31027', '#00ADEF', '#FE8200'];
            return {
                student: {user: {}, branch: {}, school: {}, btaGrade: {}},
                statuses: [],
		        googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
                semesters: semesters,
                graphData: {
                    bar: {
                        color: ['#00ADEF', '#d31027', '#38EF7D'],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {type: 'shadow'},
                            formatter: function (params) {
                                let string = params[0].name + '<br />';
                                for (let i = 0; i < params.length; i++) {
                                    let param = params[i];
                                    if (param.seriesIndex < 3 && isNaN(param.name)) {
                                        string += param.marker + param.seriesName + ': ' + param.value + '<br />';
                                    }
                                }
                                return string;
                            }
                        },
                        legend: {
                            left: 'center',
                            top: 'bottom',
                            itemWidth: 12,
                            itemHeight: 12,
                            textStyle: {padding: [0, 10, 0, 0], fontFamily: 'Ubuntu-Regular', fontSize: 14},
                            data: [
                                {name: 'Nilai Siswa', icon: 'circle'},
                                {name: 'Nilai Rata-Rata', icon: 'circle'},
                                {name: 'Nilai Tertinggi', icon: 'circle'}
                            ]
                        },
                        grid: {
                            left: '1%',
                            right: '1%',
                            containLabel: true
                        },
                        yAxis: {
                            min: 0,
                            axisLabel: {fontSize: 14, fontFamily: 'Ubuntu-Medium'},
                            axisLine: {show: false},
                            axisTick: {show: false}
                        },
                        xAxis: [
                            {
                                type: 'category',
                                data: [],
                                axisLine: {show: false},
                                axisTick: {show: false},
                                axisLabel: {
                                    interval: 0,
                                    textStyle: {fontSize: 14, fontFamily: 'Ubuntu-Bold'}
                                }
                            },
                            {
                                type: 'category',
                                data: [],
                                axisLabel: {
                                    show: false
                                }
                            }
                        ],
                        series: [
                            {
                                name: 'Nilai Siswa',
                                zlevel: 2,
                                type: 'bar',
                                itemStyle: {
                                    barBorderRadius: [50, 50, 0, 0]
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                    fontSize: 14,
                                    fontFamily: 'Ubuntu-Bold',
                                    offset: [0, -5]
                                },
                                barGap: '50%',
                                barCategoryGap: '30%',
                                data: []
                            },
                            {
                                type: 'bar',
                                zlevel: 2,
                                name: 'Nilai Rata-Rata',
                                itemStyle: {
                                    barBorderRadius: [50, 50, 0, 0]
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                    fontSize: 14,
                                    fontFamily: 'Ubuntu-Bold',
                                    offset: [0, -5]
                                },
                                data: []
                            },
                            {
                                type: 'bar',
                                zlevel: 2,
                                name: 'Nilai Tertinggi',
                                itemStyle: {
                                    barBorderRadius: [50, 50, 0, 0]
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                    fontSize: 14,
                                    fontFamily: 'Ubuntu-Bold',
                                    offset: [0, -5]
                                },
                                data: []
                            },
                            /**
                             * Bar placeholder
                             */
                            {
                                name: 'Nilai Siswa',
                                type: 'bar',
                                xAxisIndex: 1,
                                zlevel: 1,
                                barGap: '50%',
                                barCategoryGap: '30%',
                                itemStyle: {
                                    color: 'rgba(0,0,0,0.05)',
                                    barBorderRadius: [50, 50, 0, 0]
                                },
                                data: []
                            },
                            {
                                name: 'Nilai Rata-Rata',
                                type: 'bar',
                                xAxisIndex: 1,
                                zlevel: 1,
                                itemStyle: {
                                    color: 'rgba(0,0,0,0.05)',
                                    barBorderRadius: [50, 50, 0, 0]
                                },
                                data: []
                            },
                            {
                                name: 'Nilai Tertinggi',
                                type: 'bar',
                                xAxisIndex: 1,
                                zlevel: 1,
                                itemStyle: {
                                    color: 'rgba(0,0,0,0.05)',
                                    barBorderRadius: [50, 50, 0, 0]
                                },
                                data: []
                            }
                        ]
                    },
                    donuts: [
                        {
                            title: {
                                show: false
                            },
                            tooltip: {
                                show: true,
                                formatter: function (param) {
                                    return param.seriesName + '<br />' + param.marker + param.name + ': ' + param.value + '%';
                                }
                            },
                            legend: {
                                orient: 'vertical',
                                align: 'left',
                                left: 'right',
                                top: 'middle',
                                itemWidth: 15,
                                itemHeight: 15,
                                textStyle: {padding: [0, 0, 5, 10], fontFamily: 'Ubuntu-Regular', fontSize: 14},
                                data: []
                            },
                            series: [
                                {
                                    name: '',
                                    type: 'pie',
                                    radius: ['50%', '65%'],
                                    center: ['35%', '50%'],
                                    itemStyle: {
                                        color: function (params) {
                                            return colors[params.dataIndex % colors.length];
                                        },
                                        barBorderRadius: [25, 25, 0, 0]
                                    },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        fontSize: 14,
                                        fontFamily: 'Ubuntu-Bold',
                                        formatter: function (item) {
                                            return item.value + '%';
                                        }
                                    },
                                    data: []
                                }
                            ]
                        },
                        {
                            title: {
                                show: false
                            },
                            tooltip: {
                                show: true,
                                formatter: function (param) {
                                    return param.seriesName + '<br />' + param.marker + param.name + ': ' + param.value + '%';
                                }
                            },
                            legend: {
                                orient: 'vertical',
                                align: 'left',
                                left: 'right',
                                top: 'middle',
                                itemWidth: 15,
                                itemHeight: 15,
                                textStyle: {padding: [0, 0, 5, 10], fontFamily: 'Ubuntu-Regular', fontSize: 14},
                                data: []
                            },
                            series: [
                                {
                                    name: '',
                                    type: 'pie',
                                    radius: ['50%', '65%'],
                                    center: ['35%', '50%'],
                                    itemStyle: {
                                        color: function (params) {
                                            return colors[params.dataIndex % colors.length];
                                        },
                                        barBorderRadius: [25, 25, 0, 0]
                                    },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        fontSize: 14,
                                        fontFamily: 'Ubuntu-Bold',
                                        formatter: function (item) {
                                            return item.value + '%';
                                        }
                                    },
                                    data: []
                                }
                            ]
                        },
                        {
                            title: {
                                show: false
                            },
                            tooltip: {
                                show: true,
                                formatter: function (param) {
                                    return param.seriesName + '<br />' + param.marker + param.name + ': ' + param.value + '%';
                                }
                            },
                            legend: {
                                orient: 'vertical',
                                align: 'left',
                                left: 'right',
                                top: 'middle',
                                itemWidth: 15,
                                itemHeight: 15,
                                textStyle: {padding: [0, 0, 5, 10], fontFamily: 'Ubuntu-Regular', fontSize: 14},
                                data: []
                            },
                            series: [
                                {
                                    name: '',
                                    type: 'pie',
                                    radius: ['50%', '65%'],
                                    center: ['35%', '50%'],
                                    itemStyle: {
                                        color: function (params) {
                                            return colors[params.dataIndex % colors.length];
                                        },
                                        barBorderRadius: [25, 25, 0, 0]
                                    },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        fontSize: 14,
                                        fontFamily: 'Ubuntu-Bold',
                                        formatter: function (item) {
                                            return item.value + '%';
                                        }
                                    },
                                    data: []
                                }
                            ]
                        }
                    ]
                }
            };
        },
        methods: {
            addBarData(name, value, average, max) {
                this.graphData.bar.xAxis[0].data.push(name);
                this.graphData.bar.xAxis[1].data.push(name);
                this.graphData.bar.series[0].data.push(value);
                this.graphData.bar.series[1].data.push(average);
                this.graphData.bar.series[2].data.push(max);
                for (let placeholder = 3; placeholder <= 5; placeholder++) {
                    this.graphData.bar.series[placeholder].data.push(100);
                }
            },
            addDonutData(index, name, value) {
                if (this.graphData.donuts[index]) {
                    this.graphData.donuts[index].legend.data.push({name: name, icon: 'circle'});
                    this.graphData.donuts[index].series[0].data.push({name: name, value: value});
                }
            },
            resize() {
                let width = window.innerWidth || document.documentElement.clientWidth;
                for (let i = 0; i < this.graphData.donuts.length; i++) {
                    if (width < 1200) {
                        this.graphData.donuts[i].legend.orient = 'horizontal';
                        this.graphData.donuts[i].legend.left = 'center';
                        this.graphData.donuts[i].legend.top = 'bottom';

                        this.graphData.donuts[i].series[0].center = ['50%', '40%'];
                    } else {

                        this.graphData.donuts[i].legend.orient = 'vertical';
                        this.graphData.donuts[i].legend.left = 'right';
                        this.graphData.donuts[i].legend.top = 'middle';

                        this.graphData.donuts[i].series[0].center = ['35%', '50%'];
                    }
                }
            },
	    downloadCard() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/student/card/' + this.student.userID + '?' + qs.stringify({token: token}, {encode: false});
            },
            fetchStudent() {
                this.axios.get(process.env.API_URL + '/student/profile').then(response => {
                    if (response.data.status) {
                        let attendanceReports = response.data.data.uploadedAttendanceReports;
                        for (let i = 0; i < this.semesters.length; i++) {
                            this.graphData.donuts[i].series[0].name = this.semesters[i].name;
                            let attendanceReport = attendanceReports[i];
                            if (attendanceReport) {
                                this.graphData.donuts[i].legend.data = [];
                                this.graphData.donuts[i].series[0].data = [];
                                for (let index in this.statuses) {
                                    this.addDonutData(i, this.statuses[index].name, attendanceReport.values[this.statuses[index].name]);
                                }
                            }
                        }
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/student/scores'),
                this.axios.get(process.env.API_URL + '/attendance-status')
            ]).then(this.axios.spread(function (responseScore, responseStatus) {
                this.student = responseScore.data.data.student;
                this.tryouts = responseScore.data.data.tryouts;
                this.statuses = responseStatus.data.data;

                for (let i = 0; i < this.tryouts.length; i++) {
		   let tryout = this.tryouts[i];
		   if (tryout.isSimak != 1){  	
                    
                    if (typeof tryout.tryoutGroups !== typeof undefined ) {
                        for (let j = 0; j < tryout.tryoutGroups.length; j++) {
                            let tryoutGroup = tryout.tryoutGroups[j];
                            if (tryoutGroup.groupScores.length) {
                                this.addBarData(tryout.name + '\n' + tryoutGroup.groupSubject.name, tryoutGroup.groupScores[0].percentage, tryoutGroup.average, tryoutGroup.maxScore);
                            }
                        }
                    } else {
                        this.addBarData(tryout.name, tryout.totalScore, tryout.average, tryout.maxScore);
                    }
		  }
                }

                this.fetchStudent();

            }.bind(this)));
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.resize);
                this.resize();
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.resize);
        }
    };
</script>

<style scoped>
    @media (max-width: 575.98px) {
        .form-divider::before{ display: none; }
    }

    .graph-wrapper .donut-chart { height: 240px; }
    @media (max-width: 1199.98px) {
        .graph-wrapper .donut-chart { height: 300px; }
    }
</style>


// WEBPACK FOOTER //
// src/components/account/student/Index.vue